var _circle, _circle2, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 32,
    fill: "#EEF7FE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 36,
    stroke: "#F9FAFC",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 53.5L40 25L56.5 53.5H23.5ZM39.025 44.95H41.275V36.55H39.025V44.95ZM40.15 49.1125C40.475 49.1125 40.7437 49.0062 40.9562 48.7937C41.1687 48.5812 41.275 48.3125 41.275 47.9875C41.275 47.6625 41.1687 47.3938 40.9562 47.1813C40.7437 46.9688 40.475 46.8625 40.15 46.8625C39.825 46.8625 39.5562 46.9688 39.3438 47.1813C39.1313 47.3938 39.025 47.6625 39.025 47.9875C39.025 48.3125 39.1313 48.5812 39.3438 48.7937C39.5562 49.0062 39.825 49.1125 40.15 49.1125ZM27.4 51.25H52.6L40 29.5L27.4 51.25Z",
    fill: "#2C74D6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default "data:image/svg+xml,%3csvg width='80' height='80' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3ccircle cx='40' cy='40' r='32' fill='%23EEF7FE'/%3e %3ccircle cx='40' cy='40' r='36' stroke='%23F9FAFC' stroke-width='8'/%3e %3cpath d='M23.5 53.5L40 25L56.5 53.5H23.5ZM39.025 44.95H41.275V36.55H39.025V44.95ZM40.15 49.1125C40.475 49.1125 40.7437 49.0062 40.9562 48.7937C41.1687 48.5812 41.275 48.3125 41.275 47.9875C41.275 47.6625 41.1687 47.3938 40.9562 47.1813C40.7437 46.9688 40.475 46.8625 40.15 46.8625C39.825 46.8625 39.5562 46.9688 39.3438 47.1813C39.1313 47.3938 39.025 47.6625 39.025 47.9875C39.025 48.3125 39.1313 48.5812 39.3438 48.7937C39.5562 49.0062 39.825 49.1125 40.15 49.1125ZM27.4 51.25H52.6L40 29.5L27.4 51.25Z' fill='%232C74D6'/%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };